import React from 'react';

export default
<g id="button/menu/zoom" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g transform="translate(5.000000, 5.000000)" fill="currentColor" fillRule="nonzero">
        <path d="M7.00416667,2 L0.995833333,2 C0.445833333,2 0,2.44583333 0,2.99583333 L0,9.00416667 C0,9.55416667 0.445833333,10 0.995833333,10 L7.00416667,10 C7.55416667,10 8,9.55416667 8,9.00416667 L8,2.99583333 C8,2.44583333 7.55416667,2 7.00416667,2 Z M10.95,2.78541667 L8.66666667,4.36041667 L8.66666667,7.63958333 L10.95,9.2125 C11.3916667,9.51666667 12,9.20625 12,8.675 L12,3.32291667 C12,2.79375 11.39375,2.48125 10.95,2.78541667 Z"></path>
    </g>
</g>;